/* CLARO localStorage wishlist */
(function () {
  const KEY = 'claro_wishlist';

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  };
  const write = (arr) => {
    localStorage.setItem(KEY, JSON.stringify(arr));
    document.dispatchEvent(new CustomEvent('claro:wishlist:change', { detail: { items: arr } }));
  };
  const has = (handle) => read().includes(handle);
  const toggle = (handle) => {
    const arr = read();
    const i = arr.indexOf(handle);
    if (i >= 0) arr.splice(i, 1); else arr.push(handle);
    write(arr);
    return arr.includes(handle);
  };

  // expose for other scripts/pages
  window.ClaroWishlist = { read, write, has, toggle };

  // attach handlers to all .claro-heart buttons + sync state
  const refreshHearts = () => {
    document.querySelectorAll('.claro-heart').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      const active = has(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.claro-heart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.productHandle;
    if (!handle) return;
    toggle(handle);
    refreshHearts();
  });

  const refreshBadge = () => {
    const n = read().length;
    document.querySelectorAll('[data-claro-wishlist-count]').forEach((el) => {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  };

  const refreshAll = () => { refreshHearts(); refreshBadge(); };

  document.addEventListener('claro:wishlist:change', refreshAll);
  document.addEventListener('DOMContentLoaded', refreshAll);
  // Re-sync after Shopify section updates / AJAX collection re-renders
  document.addEventListener('shopify:section:load', refreshAll);

  // ---- Wishlist page renderer ----
  const renderPage = async () => {
    const root = document.querySelector('[data-claro-wishlist-root]');
    if (!root) return;
    const handles = read();
    const empty = root.querySelector('[data-empty]');
    const grid = root.querySelector('[data-grid]');

    if (!handles.length) {
      if (empty) empty.style.display = '';
      if (grid) grid.innerHTML = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (!grid) return;

    const cards = await Promise.all(handles.map(async (h) => {
      try {
        const r = await fetch(`/products/${h}.js`, { headers: { Accept: 'application/json' } });
        if (!r.ok) return null;
        const p = await r.json();
        return { handle: h, title: p.title, price: p.price, url: p.url, image: p.featured_image || (p.images && p.images[0]) };
      } catch (e) { return null; }
    }));

    grid.innerHTML = cards.filter(Boolean).map((c) => `
      <li class="claro-wishlist__card">
        <a class="claro-wishlist__card-link" href="${c.url}">
          <div class="claro-wishlist__card-img">
            ${c.image ? `<img src="${c.image}" alt="${c.title}" loading="lazy">` : ''}
          </div>
          <h3 class="claro-wishlist__card-title">${c.title}</h3>
          <p class="claro-wishlist__card-price">${(c.price / 100).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</p>
        </a>
        <button class="claro-heart claro-heart--lg is-active" data-product-handle="${c.handle}" aria-label="Remove from wishlist" aria-pressed="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" stroke="currentColor" stroke-width="1.5">
            <path d="M12 21s-7-4.35-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 11c0 5.65-7 10-7 10z"/>
          </svg>
        </button>
      </li>
    `).join('');
  };

  document.addEventListener('DOMContentLoaded', renderPage);
  document.addEventListener('claro:wishlist:change', renderPage);
})();
